<template>
  <div class="animated fadeIn">
		<b-alert
      :show="true"
      dismissible
      variant="danger"
    >
      <p>This tool is in active development and should not be used. It is available for discussion purposes only. Please do not attempt to save any changes on this page :-)</p>
    </b-alert>
	<b-card>
			<span slot="header">
				<b-row>
					<b-col>
						<h4 id="traffic" class="card-title mb-0">Mass Retargeting</h4>
					</b-col>
				</b-row>
			</span>
			<b-row>
				<b-col>
					<b-card>
						<b-card-text>
							<b-row>
								<h5>Select Geography</h5>
							</b-row>
							<b-row>
								<b-col>
									<b-form-group>
										<b-input-group size="sm">
											<b-input-group-prepend>
													<b-input-group-text>Target Geography</b-input-group-text>
												</b-input-group-prepend>
												<b-form-select v-model="market" :options="market_opts">
													<template slot="first">
														<option value="">-- Select Market --</option>
													</template>
												</b-form-select>
												<b-form-select v-model="region" :options="region_opts">
													<template slot="first">
														<option value="">-- Select Region --</option>
													</template>
												</b-form-select>
												<b-form-select v-model="area" :options="area_opts">
													<template slot="first">
														<option value="">-- Select Area --</option>
													</template>
												</b-form-select>
												<b-form-select v-model="zip" :options="zip_opts">
													<template slot="first">
														<option value="">-- Choose Zip --</option>
													</template>
												</b-form-select>
										</b-input-group>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<h5>Select Sources</h5>
							</b-row>
							<b-row>
								<b-col sm="4">
									<b-form-group>
										<b-input-group size="sm">
											<b-button size="sm" :pressed.sync="include_former_pat" variant="outline-secondary">Include Former Patients</b-button>
										</b-input-group>
									</b-form-group>

									<b-collapse id="former_pat_criteria" v-model="include_former_pat">
										<b-card>
											<b-card-text>
												<h6>Former Patients</h6>
												<b-form-group>
													<b-input-group size="sm">
														<b-input-group-prepend>
															<b-input-group-text small>Last Visit Before</b-input-group-text>
														</b-input-group-prepend>
														<b-form-input type="date" v-model="former_pat_lastvisit"></b-form-input>
														<b-input-group-append>
															<b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
														</b-input-group-append>
													</b-input-group>
												</b-form-group>

												<b-form-group>
													<b-input-group size="sm">
														<b-input-group-prepend>
															<b-input-group-text>Max Visits</b-input-group-text>
														</b-input-group-prepend>
														<b-form-input type="number" v-model="former_pat_maxvisits"></b-form-input>
														<b-input-group-append>
															<b-input-group-text><i class="fa fa-hashtag"></i></b-input-group-text>
														</b-input-group-append>
													</b-input-group>
												</b-form-group>
												<b-form-group>
													<b-input-group size="sm">
														<b-input-group-prepend>
															<b-input-group-text>Max Retargets</b-input-group-text>
														</b-input-group-prepend>
														<b-form-input type="number" v-model="former_pat_maxretargets"></b-form-input>
														<b-input-group-append>
															<b-input-group-text><i class="fa fa-hashtag"></i></b-input-group-text>
														</b-input-group-append>
													</b-input-group>
												</b-form-group>

												<b-form-group>
													<b-input-group size="sm">
														<b-input-group-prepend>
															<b-input-group-text>Last Retarget Before</b-input-group-text>
														</b-input-group-prepend>
														<b-form-input type="date" v-model="former_pat_lastretarget"></b-form-input>
														<b-input-group-append>
															<b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
														</b-input-group-append>
													</b-input-group>
												</b-form-group>
											</b-card-text>
										</b-card>
									</b-collapse>
								</b-col>
								<b-col sm="4">
									<b-form-group>
										<b-input-group size="sm">
											<b-button size="sm" :pressed.sync="include_former_lead" variant="outline-secondary">Include Former Leads</b-button>
										</b-input-group>
									</b-form-group>
									<b-collapse id="include_former_lead_criteria" v-model="include_former_lead">
										<b-card>
											<b-card-text>
												<h6>Former Leads</h6>
												<b-form-group>
													<b-input-group size="sm">
														<b-input-group-prepend>
															<b-input-group-text>Last Touch Before</b-input-group-text>
														</b-input-group-prepend>
														<b-form-input type="date" v-model="former_lead_lasttouch"></b-form-input>
														<b-input-group-append>
															<b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
														</b-input-group-append>
													</b-input-group>
												</b-form-group>

												<b-form-group>
													<b-input-group size="sm">
														<b-input-group-prepend>
															<b-input-group-text>Max Retargets</b-input-group-text>
														</b-input-group-prepend>
														<b-form-input type="number" v-model="former_lead_maxretargets"></b-form-input>
														<b-input-group-append>
															<b-input-group-text><i class="fa fa-hashtag"></i></b-input-group-text>
														</b-input-group-append>
													</b-input-group>
												</b-form-group>

												<b-form-group>
													<b-input-group size="sm">
														<b-input-group-prepend>
															<b-input-group-text>Last Retarget Before</b-input-group-text>
														</b-input-group-prepend>
														<b-form-input type="date" v-model="former_lead_lastretarget"></b-form-input>
														<b-input-group-append>
															<b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
														</b-input-group-append>
													</b-input-group>
												</b-form-group>
											</b-card-text>
										</b-card>
									</b-collapse>
								</b-col>
								<b-col sm="4">
									<b-form-group>
										<b-input-group size="sm">
											<b-button size="sm" :pressed.sync="include_recent_pat" variant="outline-secondary">Include Recent Patients</b-button>
										</b-input-group>
									</b-form-group>
									<b-collapse id="recent_pat_criteria" v-model="include_recent_pat">
										<b-card>
											<b-card-text>
												<h6>Recent Patients</h6>
												<b-form-group>
													<b-input-group size="sm">
														<b-input-group-prepend>
															<b-input-group-text>Last Visit After</b-input-group-text>
														</b-input-group-prepend>
														<b-form-input type="date" v-model="recent_pat_lastvisit"></b-form-input>
														<b-input-group-append>
															<b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
														</b-input-group-append>
													</b-input-group>
												</b-form-group>

												<b-form-group>
													<b-input-group size="sm">
														<b-input-group-prepend>
															<b-input-group-text>Max Visits</b-input-group-text>
														</b-input-group-prepend>
														<b-form-input type="number" v-model="recent_pat_maxvisits"></b-form-input>
														<b-input-group-append>
															<b-input-group-text><i class="fa fa-hashtag"></i></b-input-group-text>
														</b-input-group-append>
													</b-input-group>
												</b-form-group>

												<b-form-group>
													<b-input-group size="sm">
														<b-input-group-prepend>
															<b-input-group-text>Max Retargets</b-input-group-text>
														</b-input-group-prepend>
														<b-form-input type="number" v-model="recent_pat_maxretargets"></b-form-input>
														<b-input-group-append>
															<b-input-group-text><i class="fa fa-hashtag"></i></b-input-group-text>
														</b-input-group-append>
													</b-input-group>
												</b-form-group>

												<b-form-group>
													<b-input-group size="sm">
														<b-input-group-prepend>
															<b-input-group-text>Last Retarget Before</b-input-group-text>
														</b-input-group-prepend>
														<b-form-input type="date" v-model="recent_pat_lastretarget"></b-form-input>
														<b-input-group-append>
															<b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
														</b-input-group-append>
													</b-input-group>
												</b-form-group>
											</b-card-text>
										</b-card>
									</b-collapse>
								</b-col>
							</b-row>
							<b-row>
								<h5>Additional Filters</h5>
							</b-row>
							<b-row>
								<b-col>
									<b-form-group>
										<b-input-group size="sm">
											<b-input-group-prepend>
													<b-input-group-text>Insurance</b-input-group-text>
												</b-input-group-prepend>
												<b-form-select multiple  :select-size="3" v-model="insurance" :options="insurance_opts">

												</b-form-select>
										</b-input-group>
									</b-form-group>
								</b-col>
								<b-col>

								</b-col>
							</b-row>
						</b-card-text>
						<span slot="footer">
							<b-button-group size="sm">
								<b-button variant="success">Search</b-button>
								<b-button variant="warning">Reset</b-button>
							</b-button-group>
						</span>
					</b-card>
				</b-col>
			</b-row>
	  <b-row>
			<b-col>
				<b-card-group deck>
					<b-card no-body>
						<b-card-header>
							<i class="fa fa-crosshairs"></i> Choose Targets
							<div class="card-header-actions">
								<b-button class="card-header-action" size="sm" variant="outline-success" @click="selectAll">Select All</b-button>
								<b-button class="card-header-action" size="sm" variant="outline-danger" @click="clearSelected">Clear Selections</b-button>
              </div>
						</b-card-header>
						<b-card-text>
							<i>To select, click a row. To unselect, click again.</i>
							<b-table thead-tr-class="text-nowrap"
								selectable select-mode="multi" selected-variant="success"
								ref="selectLeads"
								@row-selected="onRowSelected"
								show-empty sticky-header small striped hover responsive
								:items="raw_data"
								:fields="fields"
								tbody-tr-class="text-nowrap"
								head-variant="light"
								style="height: 500px !important; overflow: Scroll">
							<!--<b-table striped hover :items="raw_data" :fields="table_fields">-->
								<template slot="[therapistname]" slot-scope="data">
									{{ data.item.last_name }}, {{ data.item.first_name }}&nbsp; <b-badge variant="dark" pill>{{data.item.pt_pta}}</b-badge>&nbsp;
										<b-badge v-if="data.item.ft_pt=='Full-Time'" variant="success">{{data.item.ft_pt}}</b-badge>
										<b-badge v-else variant="warning">{{data.item.ft_pt}}</b-badge>
								</template>

							</b-table>
						</b-card-text>
					</b-card>


					<b-card no-body>
						<b-card-header>
							<i class="fa fa-check"></i> Finish Up
							<div class="card-header-actions">
								<b-button class="card-header-action" size="sm" variant="outline-success" @click="createLeads"> Create Leads </b-button>
              </div>
						</b-card-header>
						<b-card-text class="m-3">
							<h6 class="mb-3">Select Target List</h6>
							<b-form-group>
								<b-input-group size="sm">
									<b-input-group-prepend>
										<b-input-group-text>Existing Taget List</b-input-group-text>
									</b-input-group-prepend>
									<b-form-select v-model="campaign" :options="campaign_opts">
										<template slot="first">
											<option value="">-- Target Lists --</option>
										</template>
									</b-form-select>
									<b-input-group-append>
										<b-button v-b-toggle.newCampaign><i class="fa fa-plus-square"></i>&nbsp;New</b-button>
									</b-input-group-append>
								</b-input-group>
							</b-form-group>
							<b-collapse id="newCampaign">
								<b-form-group>
									<b-input-group size="sm">
										<b-input-group-prepend>
											<b-input-group-text>Target List Name</b-input-group-text>
										</b-input-group-prepend>
										<b-form-input type="text" v-model="new_campaign_name" placeholder="Please name your target list"></b-form-input>
										<b-input-group-append>
											<b-input-group-text>T</b-input-group-text>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>

							</b-collapse>

						</b-card-text>
						<b-card-text>
							<h6 class="m-3">Verify {{selected_data.length}} Retargets</h6>
							<b-table style="height: 300px !important; overflow: Scroll" show-empty sticky-header small striped hover responsive :items="selected_data" :fields="fields" tbody-tr-class="text-nowrap" head-variant="light">
								<template slot="[therapistname]" slot-scope="data">
                  {{ data.item.last_name }}, {{ data.item.first_name }}&nbsp; <b-badge variant="dark" pill>{{data.item.pt_pta}}</b-badge>&nbsp;
										<b-badge v-if="data.item.ft_pt=='Full-Time'" variant="success">{{data.item.ft_pt}}</b-badge>
										<b-badge v-else variant="warning">{{data.item.ft_pt}}</b-badge>
								</template>

								<template slot="row-details" slot-scope="row">
									<b-card>
										<b-row class="mb-2">
											<b-col sm="3" class="text-sm-right"><b>Age:</b></b-col>
											<b-col>{{ row.item.age }}</b-col>
										</b-row>

										<b-row class="mb-2">
											<b-col sm="3" class="text-sm-right"><b>Is Active:</b></b-col>
											<b-col>{{ row.item.isActive }}</b-col>
										</b-row>

										<b-button size="sm" @click="row.toggleDetails">Hide Details</b-button>
									</b-card>
								</template>

							</b-table>
						</b-card-text>
					</b-card>
				</b-card-group>
			</b-col>

		</b-row>

	  <b-row>

	  </b-row>
      <div slot="footer">
        ...
      </div>
    </b-card>
  </div>
</template>

<script>
var qs = require('qs');
import moment from 'moment-timezone'
export default {
  name: 'MassRetargeting',
  mounted() {
	    this.getTherapists()
		this.getData()
		this.getGeographies()
		this.getInsurancePayers()
		this.getTargetLists()
  },
  data: function () {
    return {
			include_former_pat: true,
			include_former_lead: false,
			include_recent_pat: false,
			former_pat_lastvisit: moment().subtract(3, "months").endOf("month").format("YYYY-MM-DD"),
			former_pat_maxretargets: 3,
			former_pat_maxvisits: 16,
			former_pat_lastretarget: moment().subtract(4, "months").endOf("month").format("YYYY-MM-DD"),
			former_lead_lasttouch: moment().subtract(3, "months").endOf("month").format("YYYY-MM-DD"),
			former_lead_lastretarget: moment().subtract(4, "months").endOf("month").format("YYYY-MM-DD"),
			former_lead_maxretargets: 3,
			recent_pat_lastvisit: moment().subtract(3, "months").endOf("month").format("YYYY-MM-DD"),
			recent_pat_lastretarget: moment().subtract(4, "months").endOf("month").format("YYYY-MM-DD"),
			recent_pat_maxretargets: 3,
			recent_pat_maxvisits: 16,
			new_campaign_name: "",
			insurance: [],
			insurance_opts: [],
			campaign: "Returning Patient (Forms + RX + Verification)",
			campaign_opts: [],
			market: "",
			region: "",
			area: "",
			zip: "",
			market_opts: [],
			region_opts: [],
			area_opts: [],
			zip_opts: [],
		selected: "Month",
		active_only: false,
		since: moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD"),
		until: moment().add(1, "month").endOf("month").format("YYYY-MM-DD"),
		raw_data: [],
		selected_data: [],
		selected_therapist: '',
		therapist: '',
		therapist_obj: [],
		therapist_list: [],
		therapist_opts: [],
		therapist_opts_default: [{value: '', text: "Please select a Therapist", }],
		fields: [],
		raw_geographies: [],
    }
  },
  watch: {
	  selected: function(v, old) {
		  if (v == 'month') {
				this.since = moment().startOf("month").format("YYYY-MM-DD")
		  	this.until = moment().add(1, "month").endOf("month").format("YYYY-MM-DD")
		  } else {
				this.since = moment().startOf("month").format("YYYY-MM-DD")
		  	this.until = moment().endOf("month").format("YYYY-MM-DD")
		  }

		  // Day = Last Week, Current, Next
		  // Week = Last Week, Currnet, Next
		  // Month = Last Month, Current, Next
		  this.getData()
	  },
	  since: function(v, old) {
		  this.getData()
	  },
	  until: function(v, old) {
		  this.getData()
	  },
	  therapist_list: function (v, old) {
		  let $this = this
		  this.therapist_opts = this.therapist_opts_default
		  v.forEach( function(v, i) {
				$this.therapist_opts.push({value: i, text: `${v.last_name}, ${v.first_name}`})
		  })
	  },
	  selected_therapist: function(v, old) {
			this.therapist = v in this.therapist_list && this.therapist_list[v].hasOwnProperty('id') ? this.therapist_list[v].id :  ''
			this.therapist_obj = v in this.therapist_list ? this.therapist_list[v] : []
		  this.getData()
		},
		market: function (v, old) {
			this.processRawGeographies()
		},
		region: function (v, old) {
			this.processRawGeographies()
		},
		area: function (v, old) {
			this.processRawGeographies()
		},
		zip: function (v, old) {
			this.processRawGeographies()
		}
  },
  methods: {
		getGeographies() {
			let $this = this
			this.$newpetehealthapi.get("/geographies").then( function (r) {
				$this.raw_geographies = r.data
				$this.processRawGeographies()

				return true
			})
		},
		processRawGeographies() {
			//console.log("Processing Geos")
			let $this = this

			this.market_opts = [];
			this.region_opts = [];
			this.area_opts = [];
			this.zip_opts = [];

			// Extract the data
			Object.entries(this.raw_geographies).forEach( function(market) {
				if ( ($this.market && $this.market == market[0]) || !$this.market) {
					$this.market_opts.push(market[0])
					Object.entries(market[1]).forEach( function(region) {
						if ( ($this.market && $this.market == market[0]) || !$this.market) {
							$this.region_opts.push(region[0])
							Object.entries(region[1]).forEach( function (area) {
								if ( ($this.region && $this.region == region[0]) || !$this.region) {
									$this.area_opts.push(area[0])
									Object.entries(area[1]).forEach( function (zip) {
										if ( ($this.area && $this.area == area[0]) || !$this.area ) {
											$this.zip_opts.push(zip[1])
										}
									})
								}
							})
						}
					})
				}
			})

			// Handle hidden values
			this.market = !this.market_opts.includes(this.market) ? "" : this.market
			this.region = !this.region_opts.includes(this.region) ? "" : this.region
			this.area = !this.area_opts.includes(this.area) ? "" : this.area;
			this.zip = !this.zip_opts.includes(this.zip) ? "" : this.zip;

			// Sort the results
			this.market_opts.sort();
			this.region_opts.sort();
			this.area_opts.sort();
			this.zip_opts.sort();

			if(this.market_opts.length == 1) this.market = this.market_opts[0]
		},
		getInsurancePayers() {
			let $this = this
			this.$newpetehealthapi.get("/payers").then( function (r) {
				$this.insurance_opts = []
				r.data.forEach( function(v, i) {
					$this.insurance_opts.push(v.name)
				})

				$this.insurance_opts.sort()

				return true
			})
		},
		getTargetLists() {
			let $this = this
			this.$newpetehealthapi.get("/targetlists").then( function (r) {
				r.data.forEach( function(v, i) {
					//console.log(v)
					$this.campaign_opts.push(v.name)
				})

				$this.insurance_opts.sort()

				return true
			})
		},
		onRowSelected(items) {
			this.selected_data = items
		},
		clearSelected() {
			this.$refs.selectLeads.clearSelected()
		},
		selectAll() {
			console.log(this.$refs.selectLeads)
			this.clearSelected()
			this.selected_data = []
			let $this = this
			this.raw_data.forEach( (item,idx) => {
				$this.$refs.selectLeads.selectedRows.push(item)
				this.selected_data.push(item)
			})

			//this.$root.$emit('bv::refresh::table', 'selectLeads')
		},
		createLeads(e) {
			//console.log(e)
			return false
		},
		updateTherapist(e) {
			e.preventDefault()
			let initiator = e.srcElement
			let $this = this
			initiator.disabled="true"
			initiator.innerHTML = "Saving..."

			var target = e.srcElement.dataset.target
			var form = document.getElementById(target)
			var therapist_id = this.therapist_obj.id
			this.$newpetehealthapi.post("/therapists/"+therapist_id, {
				ft_pt: this.therapist_obj.ft_pt,
				weekly_goal: this.therapist_obj.this_weeks_goal,
				monthly_goal: this.therapist_obj.target_visits_per_month,
				pt_pta: this.therapist_obj.pt_pta,
			}).then( function (r) {
				//console.log(r)
				initiator.innerHTML = "Save"
				initiator.disabled=false
				$this.$root.$emit('bv::toggle::collapse', 'therapistprofile')
				return true;
			})
		},
		getTherapists() {
			let $this = this
			var base_url = "/therapists"
			var opts = []
			if (this.active_only !== '') {
				opts.active = true
			}

			this.$newpetehealthapi.get(base_url, {
				params: opts,
				paramsSerializer: params => {
					return qs.stringify(params)
				}
			}).then( function (r) {
				//console.log(r.data)
				$this.therapist_list = r.data
				return true
			})
		},
		getData() {
			let $this = this
			var base_url = "/tload"
			var opts = [];
			if (this.selected !== '') {
				opts.period = this.selected
			}

			if (this.therapist !== '') {
				opts.therapist_id = this.therapist
			}

			if(this.since !== '') {
				opts.since = moment(this.since).format("YYYY-MM-DD")
			}

			if(this.until !== '') {
				opts.until = moment(this.until).format("YYYY-MM-DD")
			}

			//console.log(opts)
			this.$newpetehealthapi.get(base_url, {
				params: opts,
				paramsSerializer: params => {
					return qs.stringify(params)
				}
			}).then( function (r) {
				//console.log(r.data)
				$this.fields = []
				$this.raw_data = []
				if (r.data.length > 0) {

					Object.keys(r.data[0]).forEach( function (v, i) {
						if ($this.nonext && v == 'id' && $this.group_by !== '') {
							return
						}
						$this.fields.push({key: v, sortable: v !=='id'})
					})
					$this.raw_data = r.data
			  }
				return true
			})
		},
  },

}
</script>
